import OpuEditWorkspace from '../features/opu/layouts/edit-workspace';

// TSS vite/01 §"Pages are thin". Full-screen OPU edit workspace (own tab).
export default function OpuEditPage() {
    return <OpuEditWorkspace />;
}
